import { CommonQuestionVO } from '@domain/vo/pass/interview/question/CommonQuestionVO';
import { CommonQuestionListRs, CommonQuestionRs } from '@domain/rs/pass/interview/question/CommonQuestionRs';
import { QuestionType } from '@domain/constant/questionType';

export class FrequencyQuestionVO extends CommonQuestionVO {
  type: QuestionType.FREQUENCY;

  constructor(rs: CommonQuestionRs) {
    super(rs);
    this.type = QuestionType.FREQUENCY;
  }
}

export class FrequencyQuestionListVO {
  questions: FrequencyQuestionVO[];

  constructor(rs: CommonQuestionListRs) {
    this.questions = rs.questions.map((question) => new FrequencyQuestionVO(question));
  }
}
